export default __webpack_public_path__ + "static/media/account-group.aeef0f33.svg";